// a-z A-Z 0-9 车牌号左侧3-5位，右侧4-6位
export const regVehiclePlate = /^[a-zA-Z0-9\.]{3,5}-[a-zA-Z0-9\.]{4,6}$/;

// A-Z 0-9 的17位字符串
export const regVehicleChassisNumber = /^[a-zA-Z0-9]{17,17}$/;

// a-z A-Z 0-9 6,30位
export const regVehicleEngineNumber = /^[a-zA-Z0-9]{6,30}$/;

// 只能是数字
export const regPostalCode = /^\d+$/;

// 电话号码
export const regMobileNumber = /^0?([3-9][0-9]{8}|[1-2][0-9]{9})$/;

// 含有越南注音符号
export const regDiacriticsViAlphabetReg =
  /[ÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/;

// a-z A-Z 0-9 的8或9位字符串
export const regPassportNumber =
  /^\s*(?![0-9]+$)(?![a-zA-Z]+$)[a-zA-Z0-9]{8,9}\s*$/;

// 只能是数字 9位或12位
export const regCitizenID = /^(?:\d{9}|\d{12})$/;
